import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=1318bd60"
import script from "./PreviewModal.vue?vue&type=script&lang=js"
export * from "./PreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports